import { useEffect, useState } from 'react';
import { BorrowerService } from '../../../borrowerService';
import { useTranslation } from 'react-i18next';
import { BorrowerStatus } from '../../../../../constants/borrowerStatus';
import { Box } from '@mui/material';
import { BorrowerPersonalInfo } from '../personalInformation';
import { TextWrapper } from '../../../../../shared/components/formUtilities/useTextWrapper';
import { Section } from '../../../../../shared/components/common/section';
import { BorrowerDocuments } from '../documents';
import { BorrowerBusinessInfo } from '../businessInformation';
import { SubscriptionService } from '../../../../../services/subscriptionService';
import { Toaster } from '../../../../../shared/components/common/toaster';
import { getUser } from '../../../../../services/authService';

export const BorrowerUpdateDetails = () => {
	const borrowerService = new BorrowerService();
	const subscriptionService = new SubscriptionService();
	const [borrowerPersonalInfo, setBorrowerPersonalInfo] = useState({});
	const { t } = useTranslation();
	const [isSubscribed, setIsSubscribed] = useState(null);
	const [subscriptionLoading, setSubscriptionLoading] = useState(false);

	useEffect(() => {
		getBorrowerProfilePersonalInfo();
		// Check subscription status when component mounts
		const userEmail = getUser()?.email;
		if (userEmail) {
			checkSubscriptionStatus(userEmail);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const checkSubscriptionStatus = (email) => {
		if (!email) return;
		setSubscriptionLoading(true);
		subscriptionService
			.checkSubscriptionStatus(email)
			.then((resp) => {
				const subscribed = resp.data?.subscribed ?? false;
				setIsSubscribed(subscribed);
				setSubscriptionLoading(false);
			})
			.catch((err) => {
				setIsSubscribed(false);
				setSubscriptionLoading(false);
			});
	};

	const handleSubscriptionChange = (subscriptionValue) => {
		if (subscriptionValue === null || subscriptionValue === undefined) return;
		
		const userEmail = getUser()?.email;
		if (!userEmail) {
			Toaster({ msg: 'Email not available', isError: true });
			return;
		}

		setSubscriptionLoading(true);
		const serviceCall = subscriptionValue
			? subscriptionService.subscribe(userEmail)
			: subscriptionService.unsubscribe(userEmail);

		serviceCall
			.then((resp) => {
				setIsSubscribed(Boolean(subscriptionValue));
				setSubscriptionLoading(false);
				Toaster({
					msg: subscriptionValue 
						? (t('subscribedSuccessfully') || 'Subscribed successfully')
						: (t('unsubscribedSuccessfully') || 'Unsubscribed successfully'),
					isError: !subscriptionValue
				});
			})
			.catch((err) => {
				setSubscriptionLoading(false);
				Toaster({ msg: t('errorOccurred') || 'An error occurred', isError: true });
			});
	};

	const onSavePersonalInfo = () => {
		getBorrowerProfilePersonalInfo();
	};

	const getBorrowerProfilePersonalInfo = () => {
		borrowerService
			.getBorrowerProfilePersonalInfo()
			.then((resp) => {
				setBorrowerPersonalInfo(resp.data);
			})
			.catch((err) => {});
	};

	const isApprovedByCEO = () => {
		return borrowerPersonalInfo?.status?.name === BorrowerStatus.ApprovedByCO;
	};

	return (
		<Box className="grid-flow-row grid gap-3">
			<Box className="grid-flow-row grid gap-3">
				{!isApprovedByCEO() ? <BorrowerDocuments></BorrowerDocuments> : null}
				<BorrowerPersonalInfo
					borrowerPersonalInfo={borrowerPersonalInfo}
					onSavePersonalInfo={() => {
						onSavePersonalInfo();
					}}
					isSubscribed={isSubscribed}
					subscriptionLoading={subscriptionLoading}
					onSubscriptionChange={handleSubscriptionChange}
				></BorrowerPersonalInfo>
				<BorrowerBusinessInfo></BorrowerBusinessInfo>
			</Box>
			<Section
				children={
					<TextWrapper
						classList="!info-text"
						text={
							<div>
								{t('changeSignInDetailsAdminText')}
								<a
									className="underline-link mx-1"
									href="mailto:support@fundingsouq.com">
									support@fundingsouq.com
								</a>
							</div>
						}></TextWrapper>
				}></Section>
		</Box>
	);
};
